import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedLocationId: null,
};

const selectedLocationSlice = createSlice({
    name: "selectedLocation",
    initialState,
    reducers: {
        setSelectedLocation: (state, action) => {
            state.selectedLocationId = action.payload;
        },
        clearSelectedLocation: (state) => {
            state.selectedLocationId = null;
        },
    },
});

export const selectSelectedLocationId = (state) => state.selectedLocation.selectedLocationId;

export const { setSelectedLocation, clearSelectedLocation } = selectedLocationSlice.actions;
export default selectedLocationSlice.reducer;
